/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Periods_Meta_All_OneInputs */



/**
* | output |
* | --- |
* | "1 period closed" |
*
* @param {Partner_Detail_Periods_Meta_All_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_periods_meta_all_one = /** @type {((inputs?: Partner_Detail_Periods_Meta_All_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Periods_Meta_All_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Zeitraum abgeschlossen")
	return /** @type {LocalizedString} */ ("1 period closed")
});